import { clearInputField } from '../../helpers.js'

$(document).ready(() => {
  const $form = $('form#users-beneficiary-form');

  if ($form.length === 0) {
    return;
  }

  const $isPoliticallyExposed = $('#isPoliticallyExposed input[type=radio]', $form);
  const $politicallyExposedPersonJob = $('#politicallyExposedPersonJob', $form);

  $isPoliticallyExposed.each((_, inputElement) => {
    if(inputElement.checked && inputElement.value === 'true') {
      $politicallyExposedPersonJob.removeClass('d-none');
    }
  });

  $isPoliticallyExposed.on('click', (inputElement) => {
    if(inputElement.target.value === 'false') {
      $politicallyExposedPersonJob.addClass('d-none');

      var selectedPoliticallyExposedPersonJob = document.querySelector('input[name="users_beneficiary[politically_exposed_person_job]"]:checked');

      if (selectedPoliticallyExposedPersonJob !== null) {
        clearInputField(selectedPoliticallyExposedPersonJob);
      }
    } else {
      $politicallyExposedPersonJob.removeClass('d-none');
    }
  });
})
